import { render, staticRenderFns } from "./ChatCall.vue?vue&type=template&id=37ad7fd0&scoped=true"
import script from "./ChatCall.vue?vue&type=script&lang=js"
export * from "./ChatCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad7fd0",
  null
  
)

export default component.exports